import { useAppContext } from '../../appProvider/contextProvider';
import Bell from '../../assets/images/bell.svg';
import Chrome from '../../assets/images/Chrome.svg';
import Firefox from '../../assets/images/firefox.svg';
import Opera from '../../assets/images/opera.svg';
import Safari from '../../assets/images/safari-icon.svg';


const PreviewContainer = ({
    osSelected, 
    browserSelected,
    title,
    message,
    banner,
    icon,
    is_cta_enabled,
    isCTA2Enabled,
    button,
    addl_button,
    banner_image
}) => {

    const {selectedWebsite} = useAppContext();

    const getSafariIcon = () => {
        if(browserSelected === 'Chrome') return Chrome;
        if(browserSelected === 'Firefox') return Firefox;
        if(browserSelected === 'Opera') return Opera;
        if(browserSelected === 'Safari') return Safari;
    }

    return <>
    {
        osSelected === 'Windows' && <>
            {
                (browserSelected === 'Chrome' || browserSelected === 'Opera') && 
                <div className="notification-wrapper mb-4 p-0" data-platform="windows">
                    {(banner_image || banner) && <div className="banner-image">
                        <img src={banner_image || banner} alt="banner"  width="100%" height="auto"  />
                    </div>}
                    <div className="d-flex flex-column p-3">
                        <div className="d-flex" >
                            <div className="notification-icon">
                                <img src= {icon || selectedWebsite?.logo}  alt=""/>
                            </div>
                            <div className="d-flex flex-column full-width">                                                    
                                <div className="description pl-0">
                                    <h3 className="description-title mb-0">{title || 'Notification Title'}</h3>
                                    <p className="description-text width-80 color-p mt-1">{message || ''}</p>
                                </div>
                                <div className="title color-p mt-2">
                                    Chrome {selectedWebsite?.url}
                                </div>
                            </div>
                        </div>
                        <div className={(!!addl_button || isCTA2Enabled) ? 'd-flex justify-content-between' : 'text-right' }>
                            {!is_cta_enabled && <button className="btn btn-sm action-btn">Close</button> }
                            {is_cta_enabled && <button className="btn btn-sm action-btn">
                                {button.length > 0 ? button : 'CTA Button 1'}
                                </button>}
                            {(!!addl_button || isCTA2Enabled) && <button className="btn btn-sm action-btn">
                                {addl_button.length > 0 ? addl_button : 'CTA Button 2'}
                                </button>}
                        </div>                                                
                    </div>                                          
                </div>
            }
            {
                    browserSelected === 'Firefox' && <div className="notification-wrapper mb-4" data-platform="windows-firefox">
                    <div className="d-flex justify-content-between">
                        <h3 className="description-title">{title || 'Notification Title'}</h3>                                            
                        <button className="btn btn-neutral Cancel-btn"><i className="icon icon-Cancel"></i></button>
                    </div>                                            
                    <div className="d-flex align-items-start">
                        <div className="notification-icon">
                            <img src={icon || selectedWebsite?.logo}  alt=""/>
                        </div>
                        <div className="d-flex flex-column full-width">                                                    
                            <div className="description pl-0">
                                <p className="description-text width-80 thin">{message || 'Notification Message'}</p>
                            </div>
                            <div className="d-flex justify-content-between pt-4">
                                <div className="title mb-0">
                                    via {selectedWebsite?.url}                                                           
                                </div>  
                                <i className="icon icon-settings"></i>
                            </div>                                                                                                           
                        </div>                                                
                    </div>                                          
                </div> 
            }
        </>
    }
    {
        osSelected === 'Android' && <>
            {
                (browserSelected === 'Chrome' || browserSelected === 'Opera') && <div className="notification-wrapper mb-4">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex flex-column">
                            <div className="title">
                                <img src={Bell} className="filter-image mr-2" alt="Icon"/>{browserSelected} {selectedWebsite?.url} . 16:26
                                <button className="btn btn-neutral"><i className="increment-icon default"></i></button>
                            </div>
                            <div className="description pl-0">
                                <h3 className="description-title">{title || 'Notification Title'}</h3>
                                <p className="text-grey">{message || 'Notification Message'}</p>
                            </div>
                        </div>
                        <div className="notification-icon mt-4">
                            <img src={icon || selectedWebsite?.logo} alt=""/>
                        </div>
                    </div>                                             
                    {banner && <div className="notification-banner mt-4">
                        <figure>
                            <img src={banner} width="100%" height="300px" alt=""/>
                        </figure>                                                
                    </div> }
                    <div className="mt-4">
                        {button && <button className="btn btn-neutral text-uppercase thin mr-4">{button}</button>}
                        {addl_button && <button className="btn btn-neutral text-uppercase thin mr-4">{addl_button}</button>}
                        <button className="btn btn-neutral text-uppercase thin">SITE SETTINGS</button>
                    </div>                                          
                </div> 
            }
            {
                browserSelected === 'Firefox' && <div className="notification-wrapper mb-4">
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">  
                        <div className="title">
                            <img src={Firefox} className="filter-image mr-2" alt="Icon"/>Firefox {selectedWebsite?.url} . now
                            <button className="btn btn-neutral"><i className="increment-icon default"></i></button>
                        </div>
                        <div className="description pl-0">
                            <h3 className="description-title">{title || 'Notification Title'}</h3>
                            <p className="text-grey width-50">{message || 'Notification Message'}</p>
                            <div className="mt-4">
                                <button className="btn btn-neutral text-uppercase thin">SITE SETTINGS</button>
                            </div>
                        </div>
                    </div>
                    <div className="notification-icon mt-4">
                        <img src={icon || selectedWebsite?.logo} alt=""/>
                    </div>
                </div>                                            
            </div>  
            }
        </>
    }
    {
        osSelected === 'MacOs' && <>
            {
                browserSelected === 'Safari' && <div className="notification-wrapper mb-4" data-platform="macos">
                    <div className="d-flex">
                        <div className="notification-icon">
                            <img src={Safari}  alt=""/>
                        </div>
                        <div className="d-flex flex-column full-width">                                                    
                            <div className="description pl-0">
                                <h3 className="description-title">{title || 'Notification Title'}</h3>
                                <div className="title text-grey bold">
                                    from {selectedWebsite?.url}
                                </div>
                                <p className="description-text width-60">{message || 'Notification Message'}</p>
                            </div>                                                    
                        </div>                                            
                    </div>                                          
                </div>
            }
            {
                browserSelected !== 'Safari' && <div className="notification-wrapper mb-4" data-platform="macos">
                    <div className="d-flex">
                        <div className="notification-icon">
                            <img src={getSafariIcon()}  alt=""/>
                        </div>
                        <div className="d-flex flex-column full-width">                                                    
                            <div className="description pl-0">
                                <h3 className="description-title">{title || 'Notification Title'}</h3>
                                <div className="title text-grey bold">
                                    from {selectedWebsite?.url}
                                </div>
                                <p className="description-text width-60">{message || 'Notification Message'}</p>
                            </div>                                                    
                        </div>  
                        <div className="notification-icon secondary-action">
                            <img src={icon || selectedWebsite?.logo} alt=""/>
                        </div>  
                        <div className="action-buttons">
                            <span>Cancel</span>
                            <span>Settings</span>
                        </div>                                            
                    </div>                                          
                </div>
    
            }
        </>
    }
     
    
    </>
}

export default PreviewContainer;